import { Box, IconButton, Stack, Typography, Modal, Button, styled, Tabs, Alert, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import React, { Fragment, useEffect, useMemo, useState } from "react";
import { ContentLayout } from "../UI/Template/ContentLayout";
import { RightPart } from "../UI/Template/Rightpart";
import { Leftpart } from "../UI/Template/Leftpart";
import SidebarConfigurable from "./SidebarConfigurable"
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useLocation } from "react-router-dom";
import { DUAL_ACCOUNT_REPORT } from "../../constants/reportNames";
import { useGetReportQuestions } from "../../queries/useGetSurveyScreenData";
import Loader from "../UI/Loader";
import { ArrowDownward, Cancel, Close, CloseOutlined, CloseRounded, CloudDownload, CloudUpload, Edit, Send } from "@mui/icons-material";
import { EditQuestions } from "./EditQuestions/EditQuestions";
import { useSnackbar } from "notistack";
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import classes from "./ConfigurableScreen.module.css"
import { useGetReportTemplate } from "../../hooks/useGetReportTemplate";
import { useUploadReport } from "../../queries/useUploadReport";
import WithConditional from "../hoc/WithConditional";
import { getToken } from "../../authfile";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import CustomizedSnackbars from "../UI/SnackBar";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    height: '80%',
    bgcolor: 'background.paper',
    border: '0.2rem solid #002277',
    boxShadow: 24,
    px: 3,
    overflow: 'auto',
};

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export const ConfigurableScreen = () => {
    const tokenConfig = {
        headers: {
            "Authorization": `Bearer ${getToken()}`,
        },
    };
    const [showEditPopup, setShowEditPopup] = useState(false);
    const [question, setQuestion] = useState(null);
    const { enqueueSnackbar } = useSnackbar();
    const [tabValue, setTabValue] = useState(0);
    const [uploadFile, setUploadFile] = useState();
    const [apiMessage, setApiMessage] = useState({});
    const { report } = useLocation().state || {
        report: DUAL_ACCOUNT_REPORT
    }

    const {
        data,
        isError: isConfigurableQuestionError,
        error: configurableScreenError,
        isFetching: isFetchingQuestions
    } = useGetReportQuestions({
        body: {
            report: report
        }, config: tokenConfig
    })

    const {
        mutateAsync: downloadTemplate, isLoading: isLoadingDownloadTemplate, isError: isDownloadTemplateError, error: downloadTemplateError
    } = useGetReportTemplate();

    const { mutateAsync: uploadReport, isLoading: isLoadingUploadingReport } =
        useUploadReport({ report });

    const questions = useMemo(() => {
        let groupQuestions = [];
        let groupDropdownvalues = {};
        if (data != null && data != undefined) {
            for (const x of data.DropdownData) {
                const questionId = x['Survey_Question_Id'];
                if (groupDropdownvalues[questionId] == null || groupDropdownvalues[questionId] == undefined) {
                    groupDropdownvalues[questionId] = [{ Id: x['Id'].toString(), Drop_Down_Text: x['Drop_Down_Text'] }]
                } else {
                    groupDropdownvalues[questionId].push({ Id: x['Id'].toString(), Drop_Down_Text: x['Drop_Down_Text'] })
                }
            }
        }
        if (data != null && data != undefined) {
            for (const x of data.QuestionsData) {
                const questionId = x['question_id']
                groupQuestions.push({
                    id: questionId,
                    question_text: x['question_text'],
                    values: groupDropdownvalues[questionId]
                })
            }
        }

        return groupQuestions;

    }, [data]);

    const columns = useMemo(
        () => [
            {
                accessorKey: 'question_text', //access nested data with dot notation
                header: 'Question',
                size: 350,
            },
            {
                accessorKey: 'edit',
                header: 'Edit',
                size: 50,
                Cell: ({ cell, row }) => {
                    return (
                        <IconButton onClick={() => {
                            //console.log("row is,", row)
                            if (row.original.values == null || row.original.values == undefined) {
                                enqueueSnackbar("No options for Textfield", {
                                    variant: "info"
                                })
                                return;
                            }
                            handleOpenEditQuestionPopup();
                            setQuestion(row.original);
                        }}>
                            <Edit sx={{ cursor: 'pointer' }} />
                        </IconButton>

                    )
                }
            },
        ],
        [],
    );

    const table = useMaterialReactTable({
        columns,
        data: questions || [], //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
        renderTopToolbarCustomActions: ({ table }) => (
            <Box
                sx={{
                    display: 'flex',
                    gap: '16px',
                    padding: '8px',
                    flexWrap: 'wrap',
                }}
            >
                <Typography variant="p" color="primary">{report}</Typography>
            </Box>
        ),
    });

    const handleOpenEditQuestionPopup = () => {
        setShowEditPopup(true);
    }

    const handleCloseEditQuestionPopup = () => {
        setShowEditPopup(false);
    }

    const handleChangeTabvalue = (e, newValue) => {
        setTabValue(newValue)
    }

    const handleSubmitFile = () => {
        const config = {
            headers: {
                ...tokenConfig['headers'],
                "Content-Type": "multipart/form-data",
            },
        };
        let formData = new FormData();
        formData.append("file", uploadFile);
        const res = uploadReport({ body: formData, config: config });
        //console.log("res is",res);
        res.then((result) => {
            //console.log("This is upload", result);
            if (result.data.status === "0") {
                setApiMessage({ error: true, message: result.data.message })
            } else if (result.data.status === "1") {
                setUploadFile();
                setApiMessage({ error: false, message: "File Uploaded Successfully" })
            }
        })
            .catch((err) => {
                enqueueSnackbar(`something went wrong,${err.message}`, {
                    variant: 'error'
                });
            })
    }

    useEffect(() => {
        setUploadFile();
        setApiMessage({});
    }, [report])

    //console.log("The upload file is", uploadFile);

    return (
        <ContentLayout>
            <WithConditional when={isFetchingQuestions || isLoadingDownloadTemplate || isLoadingUploadingReport}>
                <Loader />
            </WithConditional>

            <WithConditional when={isConfigurableQuestionError}>
                <CustomizedSnackbars type="error" API="Configurable Screen API" message={configurableScreenError?.message} />
            </WithConditional>
            <WithConditional when={isDownloadTemplateError}>
                <CustomizedSnackbars type="error" API="Configurable Screen Download Template API" message={downloadTemplateError?.message} />
            </WithConditional>
            <Modal
                open={showEditPopup}
                onClose={handleCloseEditQuestionPopup}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Stack sx={{ position: 'sticky', top: '-1px', backgroundColor: 'white', my: 0.5, py: 0.5, alignItems: 'center' }}>
                        <Typography variant="h6" color='#002277' sx={{ width: 'fit-content', padding: '0rem auto 2rem' }}>EDIT OPTION VALUES</Typography>
                        <Close onClick={handleCloseEditQuestionPopup} style={{ position: 'absolute', right: '0', cursor: 'pointer' }} />
                        <div style={{
                            height: '0.5vh',
                            width: '100%',
                            borderRadius: '1rem',
                            backgroundColor: '#afafb2'
                        }}></div>
                    </Stack>
                    <EditQuestions open={showEditPopup} handleCloseEditQuestionPopup={handleCloseEditQuestionPopup} question={question} report={report} />
                </Box>
            </Modal>
            <Leftpart>
                <SidebarConfigurable />
            </Leftpart>
            <RightPart>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabValue} onChange={handleChangeTabvalue} aria-label="basic tabs example">
                            <Tab label="Upload Files" {...a11yProps(0)} />
                            <Tab label="Change Option Values" {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={tabValue} index={0}>
                        <WithConditional when={apiMessage.error !== undefined}>
                            <Alert severity={apiMessage.error ? 'error' : 'success'}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    {apiMessage?.message && <Typography component="span">{apiMessage?.message.split('\n')[0]}</Typography>}
                                    {apiMessage?.message && <Typography component="span">{apiMessage?.message.split('\n')[1]}</Typography>}
                                </div>
                            </Alert>
                        </WithConditional>
                        <div className={classes.uploadFiles}>
                            <div className={classes.uploadButton}>
                                <CloudUpload color="primary" sx={{ my: 1, fontSize: '4rem' }} />
                                <Typography variant="p" sx={{ my: 1 }}>{report} TEMPLATE</Typography>
                                <Button
                                    variant="contained"
                                    component="label"
                                >
                                    Upload File
                                    <input
                                        type="file"
                                        onChange={(event) => {
                                            setUploadFile(event.target.files[0]);
                                            event.target.value = null;
                                        }}
                                        hidden
                                    />
                                </Button>
                                <WithConditional when={!!uploadFile}>
                                    <div className={classes.fileName}>
                                        <Typography variant="p">{uploadFile?.name}</Typography>
                                        <IconButton onClick={() => setUploadFile()}><Cancel sx={{ cursor: 'pointer' }} /></IconButton>
                                    </div>
                                    <Button variant="contained" onClick={() => handleSubmitFile()}>Submit <Send sx={{ mx: 1 }} /></Button>


                                </WithConditional>
                            </div>
                            <div className={classes.uploadButton}>
                                <CloudDownload color="primary" sx={{ my: 1, fontSize: '4rem' }} />
                                <Typography variant="p" sx={{ my: 1 }}>{report} TEMPLATE</Typography>
                                <Button variant="contained" sx={{ my: 1 }} onClick={() => downloadTemplate({ body: { report }, config: { headers: { ...tokenConfig['headers'] }, responseType: 'blob' } })}>
                                    Download
                                </Button>
                            </div>
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={tabValue} index={1}>
                        <MaterialReactTable table={table} />
                    </CustomTabPanel>
                </Box>
            </RightPart>
        </ContentLayout>
    )
}